/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import type { Observable } from 'rxjs';
import type { ApproveRequestResponse } from '../models/ApproveRequestResponse';
import type { DenyRequestResponse } from '../models/DenyRequestResponse';
import type { GetCountOfRequestListsResponse } from '../models/GetCountOfRequestListsResponse';
import type { GetRequestApprovalDetailsResponse } from '../models/GetRequestApprovalDetailsResponse';
import type { ListFailedPaymentsResponse } from '../models/ListFailedPaymentsResponse';
import type { ListProcessingPaymentsResponse } from '../models/ListProcessingPaymentsResponse';
import type { ListRequestsAwaitingApprovalResponse } from '../models/ListRequestsAwaitingApprovalResponse';
import type { ListRequestsToApproveResponse } from '../models/ListRequestsToApproveResponse';
import type { PayoutIssueWithRequestResponse } from '../models/PayoutIssueWithRequestResponse';
import type { ResolvePayoutIssueResponse } from '../models/ResolvePayoutIssueResponse';
import type { ResolveRequestManuallyResponse } from '../models/ResolveRequestManuallyResponse';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
@Injectable({
    providedIn: 'root',
})
export class PaymentApprovalsControllerv2Service {
    constructor(public readonly http: HttpClient) {}
    /**
     * @returns GetCountOfRequestListsResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2GetCountOfRequestLists(): Observable<GetCountOfRequestListsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/payment-approvals/counts',
        });
    }
    /**
     * @returns ListRequestsToApproveResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2ListRequestsToApprove(): Observable<Array<ListRequestsToApproveResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/payment-approvals/list-requests-to-approve',
        });
    }
    /**
     * @returns ListRequestsAwaitingApprovalResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2ListRequestsAwaitingApproval(): Observable<Array<ListRequestsAwaitingApprovalResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/payment-approvals/list-requests-awaiting-approval',
        });
    }
    /**
     * @returns ListFailedPaymentsResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2ListFailedPayments(): Observable<Array<ListFailedPaymentsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/payment-approvals/list-failed-payments',
        });
    }
    /**
     * @returns ListProcessingPaymentsResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2ListProcessingPayments(): Observable<Array<ListProcessingPaymentsResponse>> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/payment-approvals/list-processing-payments',
        });
    }
    /**
     * @param requestPseudoId
     * @param failedPaymentId
     * @returns GetRequestApprovalDetailsResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2GetRequestApprovalDetails(
        requestPseudoId: string,
        failedPaymentId?: number | null,
    ): Observable<GetRequestApprovalDetailsResponse> {
        return __request(OpenAPI, this.http, {
            method: 'GET',
            url: '/api/v2/payment-approvals/{requestPseudoId}',
            path: {
                'requestPseudoId': requestPseudoId,
            },
            query: {
                'failedPaymentId': failedPaymentId,
            },
        });
    }
    /**
     * @param requestPseudoId
     * @returns ApproveRequestResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2ApproveRequest(
        requestPseudoId: string,
    ): Observable<ApproveRequestResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/payment-approvals/approve/{requestPseudoId}',
            path: {
                'requestPseudoId': requestPseudoId,
            },
        });
    }
    /**
     * @param requestPseudoId
     * @param reason
     * @returns DenyRequestResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2DenyRequest(
        requestPseudoId: string,
        reason?: string | null,
    ): Observable<DenyRequestResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/payment-approvals/deny/{requestPseudoId}',
            path: {
                'requestPseudoId': requestPseudoId,
            },
            query: {
                'reason': reason,
            },
        });
    }
    /**
     * @param requestPseudoId
     * @param reason
     * @returns PayoutIssueWithRequestResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2PayoutIssueWithRequest(
        requestPseudoId: string,
        reason?: string | null,
    ): Observable<PayoutIssueWithRequestResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/payment-approvals/payout-issue/{requestPseudoId}',
            path: {
                'requestPseudoId': requestPseudoId,
            },
            query: {
                'reason': reason,
            },
        });
    }
    /**
     * @param requestPseudoId
     * @param reason
     * @returns ResolvePayoutIssueResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2ResolvePayoutIssue(
        requestPseudoId: string,
        reason?: string | null,
    ): Observable<ResolvePayoutIssueResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/payment-approvals/resolve-issue/{requestPseudoId}',
            path: {
                'requestPseudoId': requestPseudoId,
            },
            query: {
                'reason': reason,
            },
        });
    }
    /**
     * @param requestPseudoId
     * @param reason
     * @returns ResolveRequestManuallyResponse
     * @throws ApiError
     */
    public paymentApprovalsControllerv2ResolveRequestManually(
        requestPseudoId: string,
        reason?: string | null,
    ): Observable<ResolveRequestManuallyResponse> {
        return __request(OpenAPI, this.http, {
            method: 'PUT',
            url: '/api/v2/payment-approvals/resolve-request-manually/{requestPseudoId}',
            path: {
                'requestPseudoId': requestPseudoId,
            },
            query: {
                'reason': reason,
            },
        });
    }
}
